import react, { useState, useEffect, use } from "react";
import { useParams } from "react-router-dom";
import TimeZonePicker from "./TimeZonePicker";
import TimePickerSelect from "./TimePickerSelect";

const SetAvailabilityModal = (props) => {
    
    const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

    let availabilityIndex = props.availability?.length - 1 || 0;

    let priorFrom = props.availability?.length > 0 ? props.availability[availabilityIndex]?.from : "17:00";
    let priorTo = props.availability?.length > 0 ? props.availability[availabilityIndex]?.to : "20:30";
    
    const [day, setDay] = useState(props.dayClicked || "");
    const [fromTime, setFromTime] = useState(priorFrom || "9:00");
    const [toTime, setToTime] = useState(priorTo || "17:00");
    const [availability, setAvailability] = useState(props.availability || []);
    const [timeZone, setTimeZone] = useState(props.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone);
    const [showAddTimeSlotToScheduleForDay, setShowAddTimeSlotToScheduleForDay] = useState(null);

    useEffect(() => {
        setDay(props.dayClicked || "");
    }, [props.dayClicked]);

     const handleSubmitAvailability = (theNewAvailability) => {
        const response = fetch(`${process.env.REACT_APP_API_URL}/guide/set-guide-availability/${props.guideId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ availability: theNewAvailability, timeZone: timeZone })
        });
        response.then(res => res.json()).then(data => {
            if(data.success) {
                setAvailability(theNewAvailability);
                props.setMadeEdit(true);
                if(props.setAvailability) {
                    props.setAvailability(theNewAvailability);
                }
            } else {
                if(data.expiredToken) {
                    if(props.showTheExpiredTokenModal) {
                        props.showTheExpiredTokenModal();
                    }
                    return;
                }
                console.error("Error setting availability:", data.message);
            }
        });
    };

    const handleFromTimeChange = (value) => {
        console.log("From time changed:", value);
        setFromTime(value);
    }

    const handleToTimeChange = (value) => {
        console.log("To time changed:", value);
        setToTime(value);
    }

    const convertMilitaryToAMPM = (time) => {
        const [hours, minutes] = time?.split(":").map(Number);
        const period = hours >= 12 ? "PM" : "AM";
        const adjustedHours = hours % 12 === 0 ? 12 : hours % 12;
        return `${adjustedHours}:${minutes.toString().padStart(2, "0")} ${period}`;
    };

    const compareDays = (a, b) => {
        return daysOfWeek.indexOf(a.day) - daysOfWeek.indexOf(b.day);
    };

    const setTheTimeZone = (tz) => {
        setTimeZone(tz);
        if(props.setTimeZone) {
            props.setTimeZone(tz);
        }
    };

    return (
        <div style={{ display: props?.show ? 'block' : 'none' }} className='a-modal-container'>
            <div className="select-archetype-modal-overlay" onClick={() => props?.setShow(false)}></div>
            <div className="select-archetype-modal">
                <div className="select-archetype-modal-header">
                    <button className="select-archetype-modal-close-button" onClick={() => props?.setShow(false)} style={{position: "absolute", top: "10px", right: "10px", background: "none", border: "none", cursor: "pointer"}}>❌</button>
                </div>
                <div className="a-modal-body">
                    <span className="lucky-font">Set Availability</span>
                    <div style={{margin: "20px 0"}}>
                        <TimeZonePicker onChange={(tz) => setTheTimeZone(tz)} timeZone={timeZone} country={props.country} setCountry={props.setCountry} />
                    </div>
                    <div className="availability-selection-container">
                        <select className="set-availability-day" value={day} onChange={(e) => setDay(e.target.value)}>
                            <option value="">Select a Day</option>
                            <option value="Monday">Monday</option>
                            <option value="Tuesday">Tuesday</option>
                            <option value="Wednesday">Wednesday</option>
                            <option value="Thursday">Thursday</option>
                            <option value="Friday">Friday</option>
                            <option value="Saturday">Saturday</option>
                            <option value="Sunday">Sunday</option>
                        </select>
                        {day && (
                            <div style={{marginTop: "20px"}}>
                                <div className="time-slot-inputs">
                                    <label>
                                        From: <br />
                                        <TimePickerSelect
                                            value={fromTime}
                                            onChange={handleFromTimeChange}
                                            step={30}
                                        />
                                    </label>
                                    <label>
                                        To: <br />
                                        <TimePickerSelect
                                            value={toTime}
                                            onChange={handleToTimeChange}
                                            step={30}
                                        />
                                    </label>
                                </div>
                                <button className="add-timeslot-to-schedule-button" style={{marginTop: "10px"}} onClick={() => {
                                    if(fromTime && toTime) {
                                        const newAvailability = [...availability, { day, from: fromTime, to: toTime }];
                                        setAvailability(newAvailability);
                                        if(props.setAvailability) {
                                            props.setAvailability(newAvailability);
                                        }
                                    }
                                }}>Add Time Slot to Schedule</button>
                            </div>
                        )}
                    </div>
                    <div style={{margin: "20px auto"}}>
                        <h3>Current Availability:</h3>
                        <div className="available-days-flex-grid">
                            {daysOfWeek.map((d) => {
                                const slotsForDay = availability.filter(slot => slot.day.toLowerCase() === d.toLowerCase());
                                return (
                                    <div className="available-days-flex-item" key={d}>
                                        <div key={d} onClick={() => { setDay(d); setShowAddTimeSlotToScheduleForDay(d)}}>
                                            <h4 key={d} style={{fontWeight: "bold", marginTop: "10px"}}>{d}</h4>
                                            {slotsForDay.sort((a, b) => compareDays(a, b) || a.from.localeCompare(b.from)).map((slotForDay, index) => {
                                                        return (
                                                            <div style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", marginBottom: "5px"}} key={slotForDay+" "+index}>
                                                                {convertMilitaryToAMPM(slotForDay.from)} - {convertMilitaryToAMPM(slotForDay.to)}
                                                                <span style={{cursor: "pointer", color: "red", marginLeft: "10px"}} onClick={() => {
                                                                    const newAvailability = availability.filter(slot => !(slot.day === d && slot.from === slotForDay.from && slot.to === slotForDay.to));
                                                                    setAvailability(newAvailability);
                                                                    if(props.setAvailability) {
                                                                        props.setAvailability(newAvailability);
                                                                    }
                                                                }}>❌</span>
                                                            </div>
                                                        );
                                                    })
                                            }
                                        </div>
                                        {showAddTimeSlotToScheduleForDay === d && (
                                        <div>
                                            <button className="add-timeslot-to-schedule-button" style={{marginTop: "10px"}} onClick={() => {
                                                if(fromTime && toTime) {
                                                    const newAvailability = [...availability, { day, from: fromTime, to: toTime }];
                                                    setAvailability(newAvailability);
                                                    if(props.setAvailability) {
                                                        props.setAvailability(newAvailability);
                                                    }
                                                }
                                            }}>Add Time Slot to Schedule</button>
                                        </div>
                                        )}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <button className="center-form-button" onClick={() => { props?.setShow(false); handleSubmitAvailability(availability) }} style={{marginTop: "10px", padding: "10px 20px", fontSize: "18px", cursor: "pointer"}}>
                    Done
                </button>
            </div>
        </div>
    );
};

export default SetAvailabilityModal;